import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import { Cell, Row } from '@components/main/spreading/models/models';
import { SourceComment } from '@components/main/spreading/models/source-comment';
import { SpreadingState } from '@components/main/spreading/state/manager';
import {NgxPopupComponent} from "@components/shared/ngx-popups/ngx-popups/components/popup.component";

@Component({
    selector: 'app-comment-modal',
    templateUrl: './comment-modal.component.html',
    styleUrls: ['./comment-modal.component.scss'],
    standalone: false
})
export class CommentModalComponent {
  @Input() popup: NgxPopupComponent;

  @Input() cellWithComment: Cell;
  @Input() rowWithCell: Row;

  @Input() spreadingState: SpreadingState;

  @Input() isStatementDateComment: boolean = false;
  @Input() statementDate: string = '';

  @Output() saveComment: EventEmitter<any> = new EventEmitter<any>();

  constructor(
  ) {
    // Constructor
  }

  closeModal() {
    this.popup.close();
  }

  cancel() {
    if (this.cellWithComment.sourceComments?.length !== 0) {
      this.cellWithComment.sourceComments[0].action = null;
    }
    this.closeModal();
  }

  saveSpreadingComment(commentText): void {
    if (this.cellWithComment.sourceComments.length === 0) {
      // When creating a new comment, we need to set the action to CREATE
      this.cellWithComment.sourceComments[0] = {
        id: null,
        uuid: null,
        comment: '',
        reviewQueueItemId: null,
        sourcePageNumber: null,
        sourceBoxUlcX: null,
        sourceBoxUlcY: null,
        sourceBoxUrcX: null,
        sourceBoxUrcY: null,
        sourceBoxLrcX: null,
        sourceBoxLrcY: null,
        sourceBoxLlcX: null,
        sourceBoxLlcY: null,
        statementId: null,
        action: 'CREATE',
      }
    } else {
      // When saving an existing comment, we need to set the action to UPDATE
      this.cellWithComment.sourceComments[0].action = 'UPDATE';
    }
    this.cellWithComment.sourceComments[0].reviewQueueItemId = this.spreadingState.reviewQueueItem.id;
    this.populateSourceComment(this.cellWithComment.sourceComments[0], this.spreadingState, commentText.value);
    this.saveComment.emit();
    this.closeModal();
    return;
  }

  private populateSourceComment(sourceComment: SourceComment, spreadingState: SpreadingState, commentText: string): void {
    sourceComment.comment = commentText;
    sourceComment.statementId = spreadingState.statement.id;
  }

  protected readonly document = document;
}
